
export const list = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `https://192.168.0.202/fuelphp/public/money/rest/bklist.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;

    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

